export default "__VITE_ASSET__BqCD7Vvk__"